import Tasks from '../../../../components/AdminSettings/Tasks';
import {
  Divider,
  NavigateBack,
  Typography,
} from '../../../../designComponents';
import { RulesStyled } from './style';

const Rules = () => {
  return (
    <RulesStyled>
      <NavigateBack />
      <Typography>Rules</Typography>
      <Divider />
      <Tasks />
    </RulesStyled>
  );
};

export default Rules;
